import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, IconButton, useMediaQuery } from '@mui/material';
import OpenMenuIcon from "../../../../assets/menu/openMenuIcon";
import useMenuAction from "../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../hooks/menu/useMenuData";
import { DRAWER_WIDTH } from "../../../../themes/config";

// project import
import AppBarStyled from './appBarStyled';
import HeaderContent from "./headerContent/headerContent";

// assets

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = () => {
	const { drawerOpen } = useMenuData()
	const { setDrawerOpen } = useMenuAction()
	const theme = useTheme();
	const downLG = useMediaQuery(theme.breakpoints.down('lg'));
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));
	// header content
	const headerContent = useMemo(() => <HeaderContent/>, []);

	const mainHeader = (
		<Toolbar
			sx={{
				width: '100%',
				pt: 'auto',
				backgroundColor: 'transparent',
			}}
		>
			{downSM && (
				<IconButton
					aria-label="open drawer"
					onClick={() => setDrawerOpen(!drawerOpen)}
					sx={{
						// p: '16px',
						borderRadius: '16px'
					}}
				>
					<OpenMenuIcon/>
				</IconButton>
			)}
			{headerContent}
		</Toolbar>
	)
	
	// app-bar params
	const appBar = {
		position: 'absolute',
		color: 'inherit',
		elevation: 0,
		sx: {
			zIndex: 10,
			width: downSM ? '100%' : drawerOpen ? `calc(100% - ${DRAWER_WIDTH})` : 'calc(100% - 60px)',
			backgroundColor: 'transparent',
			paddingRight: '0 !important'
		}
	};
	
	return (
		<>
			{!downLG ? (
				<AppBarStyled open={drawerOpen} {...appBar}>
					{mainHeader}
				</AppBarStyled>
			) : (
				<AppBar {...appBar}>{mainHeader}</AppBar>
			)}
		</>
	);
};

export default Header;
